"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'account.upgrade.errors.loadGrades': 'Błąd ładowania pakietów cenowych',
    'account.upgrade.loadingGrades': 'Ładowanie pakietów cenowych...',
    'account.upgrade.title': 'Aktualizacja Konta',
    'account.upgrade.currentGrade': 'Aktualny Poziom Konta',
    'account.upgrade.selectGrade': 'Twój plan',
    'account.upgrade.save': 'Zapisz Zmiany',
    'account.upgrade.payNow': 'Zapłać Teraz i Ulepsz',
    'account.upgrade.downgrade': 'Przejdź na Niższy Plan',
    'account.upgrade.mostPopular': 'Najbardziej Popularna',
    'account.upgrade.selectPlan': 'Wybierz Plan',
    'account.upgrade.selected': 'Wybrany',
    'account.upgrade.success': 'Poziom konta został pomyślnie zaktualizowany',
    'account.upgrade.paymentInitiated': 'Płatność została zainicjowana. Proszę dokończyć płatność, aby uaktualnić konto.',
    'account.upgrade.errors.general': 'Nie udało się zaktualizować poziomu konta',
    'account.upgrade.errors.loadUser': 'Nie udało się załadować informacji o użytkowniku',
    'account.upgrade.errors.noUser': 'Nie znaleziono użytkownika',
    'account.upgrade.credits': 'kredyty',
    'account.upgrade.noCredits': 'Brak kredytów w pakiecie',
    'account.upgrade.perMonth': 'miesięcznie',
    'account.upgrade.changePlan': 'Zmień Plan',
    'account.upgrade.currentPlan': 'Obecny Plan',
    'account.upgrade.futureGradeInfo': 'Ten plan zostanie aktywowany',
    'account.upgrade.confirm.title': 'Potwierdź Zmianę Planu',
    'account.upgrade.confirm.downgrade': 'Czy na pewno chcesz przejść na plan darmowy? Stracisz dostęp do funkcji premium.',
    'account.upgrade.confirm.change': 'Czy na pewno chcesz zmienić swój plan na',
    'account.upgrade.success.changed': 'Twój plan został pomyślnie zmieniony',
    'account.upgrade.success.upgraded': 'Konto zostało pomyślnie uaktualnione!',
    'account.upgrade.errors.changeFailed': 'Nie udało się zmienić planu',
    'account.upgrade.errors.paymentFailed': 'Płatność nie powiodła się. Spróbuj ponownie.',
    'account.upgrade.monthly': 'Miesięcznie',
    'account.upgrade.yearly': 'Rocznie',
    'account.upgrade.saveMore': 'Oszczędź Więcej',
    'account.upgrade.discount': 'ZNIŻKA',
    'account.upgrade.save_money_amount': 'Oszczędź',
};
